module.exports = __webpack_public_path__ + "img/picto-main-oeuvre.bfcb87a0.svg";